// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__adb {
  position: relative;
}

.floatingLabelWrapper__a87 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  border-color: transparent;
  border-style: solid;

  pointer-events: none;

  .textInvisibleBoundary__e38 {
    visibility: hidden;
  }

  .floatingLabel__f41 {
    animation: fadeIn__f7b 0.3s;
    color: var(--ring-secondary-color);
    margin-left: var(--ring-unit);
  }
}

@keyframes fadeIn__f7b {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/floating-label-input/floating-label-input.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;;EAEnB,oBAAoB;;EAEpB;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAAsB;IACtB,kCAAkC;IAClC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.floatingLabelWrapper {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  border-color: transparent;\n  border-style: solid;\n\n  pointer-events: none;\n\n  .textInvisibleBoundary {\n    visibility: hidden;\n  }\n\n  .floatingLabel {\n    animation: fadeIn 0.3s;\n    color: var(--ring-secondary-color);\n    margin-left: var(--ring-unit);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__adb`,
	"floatingLabelWrapper": `floatingLabelWrapper__a87`,
	"fadeIn": `fadeIn__f7b`,
	"textInvisibleBoundary": `textInvisibleBoundary__e38`,
	"floatingLabel": `floatingLabel__f41`
};
export default ___CSS_LOADER_EXPORT___;
